import styled from 'styled-components';
import { Drawer } from 'antd';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-mask {
    z-index: 1000;
  }

  .ant-drawer-body {
    padding: 0 40px;
  }

  .ant-drawer-header {
    color: rgb(0 0 0 / 85%);
    font-weight: 500;
  }
`;
export const Container = styled.div`
  display: flex;
  height: calc(100vh - 64px);
  align-items: center;
  justify-content: center;
  min-width: 1200px;
  overflow: scroll;
  position: relative;
  background-color: #fff;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 80px;
  height: 100%;
  width: 738px;
  padding: 80px 0 24px;
  background-color: white;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 400px;
`;

export const Image = styled.img`
  max-width: 100%;
  height: auto;
`;
export const SubTitle = styled.div`
  color: #000;
  font-size: 28px;
  font-style: normal;
  font-weight: 300;
  line-height: 120%;
`;
export const Title = styled.div`
  color: #000;
  font-size: 38px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
`;
export const FeaturesGrid = styled.div`
  display: grid;
  gap: 3rem;
  height: 130px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const FeatureBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 12px;
  position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    right: -25px;
    top: 0;
    width: 1px;
    height: 100%;
    background-color: #e5e7eb;
  }

  @media (max-width: 767px) {
    &:not(:last-child)::after {
      content: none;
    }
  }
`;

export const FeatureTitle = styled.div`
  margin-bottom: 16px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  color: #4c4c4c;
`;

export const IconGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 4px;
  align-items: center;
  opacity: 0.6;
`;

export const IconBox = styled.img`
  height: 36px;
  width: 36px;
`;

export const FeatureText = styled.div`
  color: #818181;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`;

export const ProductHighlights = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const TrustBar = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 20px;
`;

export const GartnerBoxText = styled.span`
  color: #002957;
  font-size: 14px;
  font-weight: 700;
`;

export const RatingText = styled.div`
  color: #000;
  font-size: 20px;
  margin: 0 10px 0 16px;
`;

export const FAQ = styled.div`
  color: #4c4c4c;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`;

export const LastStep = styled.div`
  color: #4c4c4c;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

export const DoNotShowButtonWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const DoNotShowButton = styled.div`
  color: #1f1f1f;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
`;
